module.exports = __webpack_public_path__ + "img/Wp_2087.6cf08eff.png";